import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import config from 'config/default.json';
import { HelperModule } from 'src/app/back-office/modules/helper.module';

@Component({
  selector: 'app-activity-details',
  templateUrl: './activity-details.component.html',
  styleUrls: ['./activity-details.component.scss']
})
export class ActivityDetailsComponent implements OnInit{
  
  activityForm!: FormGroup;
  userAssignedControl = new FormControl();
  userBeneficiaryControl = new FormControl();
  wavesControl = new FormControl();
  activity: 'task' | 'expense' = 'expense';
  mode: 'create' | 'edit' | 'view' = 'create';

  waves :any[] = [];
  waveSorted :any[] = [];
  categories :any[] = [];
  taskStatus:any[] = [];
  taskPriorities : any[] = [];
  expenseCoverage :any[] = [];
  expenseStatus:any[] = [];

  users: any[] = [];
  usersAssigned: any[] = [];
  usersBeneficiary: any[] = [];
  linkedTasks: any[] = [];
  attachments: any[] = [];
  deleteAttachments: any[] = [];
  comments: any[] = [];
  newComment = '';

  userInfos: any = {};
  rowInfos: any = {};
  isInternalExpense:boolean = false;
  selectedUserExpenseOwner: any = null;
  selectedUserExpenseBeneficiary: any = null;
  userWaves:any = [] = [];

  expensesData: any[] = [];
  expenseSections: any[] = [];
  totalExpense = 0;
  totalContent = 0;



  constructor(
    private fb: FormBuilder,
    public helper: HelperModule,
    public dialogRef: MatDialogRef<ActivityDetailsComponent>,
    private apiService: ApiServiceModule,
    @Inject(MAT_DIALOG_DATA) public data: { [x: string]: any }
  ) {
    this.activity = data['activity'] || 'expense';
    this.mode = data['mode'] || 'create';
    this.userInfos = data['user_infos'] || {};
    this.rowInfos = data['row_infos'] || {};
    this.waves = data['waves'] || [];
    this.categories = data['categories'] || [];
    this.taskStatus = data['task_status'] || [];
    this.taskPriorities = data['task_priorities'] || [];
    this.expenseCoverage = data['expense_coverages'] || [];
    this.expenseStatus = data['expense_status'] || [];
    this.users = data['users'] || [];
    this.usersAssigned = data['users'] || [];
    this.usersBeneficiary = data['users'] || [];
    this.linkedTasks = data['linked_tasks'] || [];
  }
  ngOnInit(): void {
    this.activityForm = this.activity == 'task'? this.fb.group({
      title: [null, Validators.required],
      objective: [null],
      id_category: [null, Validators.required],
      description: [null],
      priority: [null, Validators.required],
      status: [null, Validators.required],
      progress: [0, [Validators.min(0), Validators.max(100)]],
      start_date: [null],
      end_date: [null],
      completed_date: [null],
      estimated_hours: [null],
      completed_hours: [null],
      id_user_assigned: [[] as number[], Validators.required],
      comment: [null]
    }):
    this.fb.group({
      title: [null, Validators.required],
      objective: [null],
      id_category: [null, Validators.required],
      description: [null],
      coverage: [null, Validators.required],
      status: [null, Validators.required],
      amount_euro: [null, Validators.required],
      amount_cfa: [null],
      start_date: [null, Validators.required],
      end_date: [null, Validators.required],
      waves: [[] as number[]],
      payed_date: [null],
      id_user_assigned: [null, Validators.required],
      id_user_beneficiary: [null],
      name_beneficiary: [null],
      comment: [null]
    });
    this.userWaves = Array.from({ length: 12 }, (_, i) => {
        const date = new Date();
        date.setDate(1);
        date.setMonth(date.getMonth() - i);
        const month = date.getMonth() + 1;
        return {
            ...this.waves.find(m => m.id === month),
            id: `${month}-${date.getFullYear()}`,
            name_fr: `${this.waves.find(m => m.id === month)?.name_fr} ${date.getFullYear()}`
        };
    });
    this.userAssignedControl.valueChanges.pipe(
      filter(query => query && query.length > 2),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((query) => {
        return this.apiService.queryData(config.master.ndapi.url+'/enovsky/web/administration/search_user', {search_key: query}, this.userInfos['access_token'])
      })).subscribe((options) => {
      this.usersAssigned = options;
    });
    this.userBeneficiaryControl.valueChanges.pipe(
      filter(query => query && query.length > 2),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((query) => {
        return this.apiService.queryData(config.master.ndapi.url+'/enovsky/web/administration/search_user', {search_key: query}, this.userInfos['access_token'])
      })).subscribe((options) => {
      this.usersBeneficiary = options;
    });
    this.activityForm.get('status')?.valueChanges.subscribe(status => {
      if(this.activity == 'expense'){
        const payedDate = this.activityForm.get('payed_date');
        if(status === 'paid') payedDate?.setValidators([Validators.required]);
        else payedDate?.clearValidators();
        payedDate?.updateValueAndValidity();
      }
      if(this.activity == 'task'){
        const completedHours = this.activityForm.get('completed_hours');
        const completedDate = this.activityForm.get('completed_date');
        if (status === 'done') {
          completedHours?.setValidators([Validators.required]);
          completedDate?.setValidators([Validators.required]);
          this.activityForm.get('progress')?.setValue(100);
        } else {
          completedHours?.clearValidators();
          completedDate?.clearValidators();
        }
        completedHours?.updateValueAndValidity();
        completedDate?.updateValueAndValidity();
      }
      
    });
    if (['edit', 'view'].includes(this.mode)) this.loadActivity();
    if (this.mode === 'view') this.activityForm.disable();
  }
  saveTask(): void {
    if (this.mode === 'view') return;
    if (this.activityForm.invalid) {
      this.activityForm.markAllAsTouched();
      const errors = Object.keys(this.activityForm.controls)
      .filter(key => this.activityForm.get(key)?.invalid)
      .reduce((acc, key) => {
          acc[key] = this.activityForm.get(key)?.errors;
          return acc;
      }, {} as { [key: string]: any });
      console.log(errors);
      return;
    }
    const formData = new FormData();
    const data = this.activityForm.getRawValue();
    data.start_date = this.formatDate(data.start_date);
    data.end_date = this.formatDate(data.end_date)?.replace('00:00:00', '23:59:59') ?? null;
    data.completed_date = this.formatDate(data.completed_date);
    
    data.payed_date = this.formatDate(data.payed_date);

    const comment = String(data['comment'] || '').trim();

    if (comment) {
      this.comments.push({
        author: this.userInfos['full_name'] || this.userInfos['name'] || 'Vous',
        message: comment,
        date: this.formatDate(new Date())
      });
    }
    this.attachments.filter((item: any) => item.file).forEach((item: any) => {
      formData.append('file', item.file, item.name);
    });
    const formDataTask = {
      ...data,
      id_user_creator: this.userInfos['id_user'],
      id_expense: this.rowInfos['id'] ?? null,
      id_task: this.rowInfos['id'] ?? null,
      id_priority: this.activity == 'task'? this.taskPriorities.find((el:any)=> el.keyword == data.priority)?.id: null,
      id_coverage: this.activity == 'expense'? this.expenseCoverage.find((el:any)=> el.keyword == data.coverage)?.id: null,
      id_status: this.activity == 'task'? this.taskStatus.find((el:any)=> el.keyword == data.status).id: this.expenseStatus.find((el:any)=> el.keyword == data.status)?.id,
      mode: this.mode,
      activity: this.activity,
      is_internal_expense: this.isInternalExpense,
      expense_details: this.expensesData,
      delete_attachments:  this.deleteAttachments,
      comments: this.comments
    };
    formData.append('data', JSON.stringify(formDataTask));
    this.apiService.uploadDataAndFile(config.master.ndapi.url + '/enovsky/web/management/action', formData, this.userInfos['access_token']).subscribe((response:any)=>{
      this.helper.showToast(response.message);
      this.dialogRef.close();
    });
    
    delete formDataTask['comment'];
    
  }
  get isViewMode(): boolean {
    return this.mode === 'view';
  }
  onExpenseOwnerChange(userId: number): void {
    this.selectedUserExpenseOwner = this.usersAssigned.find(user => user.id === userId) || null;
  }
  onBeneficiaryChange(userId: number): void {
    this.selectedUserExpenseBeneficiary = this.usersBeneficiary.find(user => user.id === userId) || null;
    let yearWaves = this.activityForm?.get('waves')?.value || [];
    let data = {
      id_users: [userId],
      year_waves: yearWaves
    }
    if(yearWaves.length > 0)
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/management/load_beneficiary_infos', data, this.userInfos['access_token']).subscribe((response: any)=>{
      
      this.expensesData = response;
      this.buildExpenseRecap();
    });
  }
  buildExpenseRecap(): void {
    const sections = [
        { type: 'acquisition', title: 'Acquisition de contenu' },
        { type: 'classification', title: 'Classification de contenu' },
        { type: 'edition', title: 'Édition de contenu' }
    ];

    this.expenseSections = sections.map(section => {
        const rows = this.expensesData.filter(
            (item: any) => item.type === section.type
        );

        return {
            ...section,
            rows,
            total: rows.reduce((sum: number, item: any) => sum + Number(item.price || 0), 0),
            nbContent: rows.reduce((sum: number, item: any) => sum + Number(item.nb_content || 0), 0),
            nbWord: rows.reduce((sum: number, item: any) => sum + Number(item.nb_word || 0), 0),
            displayedColumns: section.type === 'edition'
                ? ['user', 'wave', 'origin', 'nb_content', 'nb_word', 'unit_price', 'price']
                : ['user', 'wave', 'origin', 'nb_content', 'unit_price', 'price']
        };
    }).filter(section => section.rows.length > 0);

    this.totalExpense = this.expenseSections.reduce(
        (sum, section) => sum + section.total, 0
    );

    this.totalContent = this.expenseSections.reduce(
        (sum, section) => sum + section.nbContent, 0
    );
    this.activityForm.get('amount_cfa')?.setValue(this.totalExpense);
    this.convertFromCfa();
  }
  get selectedUsersAssigned(): any[] {
    const ids = this.activityForm?.get('id_user_assigned')?.value || [];
    return this.usersAssigned.filter(user => ids.includes(user.id));
  }

  loadActivity(): void {
    const row = this.rowInfos || {};
    this.attachments = (row['attachments'] || []).map((file:any) => ({
        ...file,
        size: this.formatFileSize(file.size)
    })) ?? [];
    this.comments = this.parseJson(row['comments']);
    this.isInternalExpense = this.rowInfos.is_internal_expese;
    this.selectedUserExpenseOwner = this.activity == 'expense'? this.users.find((el)=> el.id == row['id_user_assigned']): null;
   
    this.activityForm.patchValue({
      title: row['title'] ?? null,
      objective: row['objective'] ?? null,
      id_category: row['id_category'] ?? null,
      description: row['description'] ?? '',
      priority: row['priority_key'] ?? null,
      status: row['status_key'] ?? null,
      progress: row['progress'] ?? 0,
      coverage: row['coverage_key'] ?? null,
      amount_euro: row['amount_euro'] ?? null,
      amount_cfa: row['amount_cfa'] ?? null,
      waves: row['waves'] ?? null,
      payed_date: row['pay_date'] ? this.toDate(row['pay_date']): null,
      start_date: row['start_date'] ? this.toDate(row['start_date']): null,
      end_date: row['end_date'] ? this.toDate(row['end_date']): null,
      completed_date: row['completed_date'] ? this.toDate(row['completed_date']): null,
      estimated_hours: row['estimated_hours'] ?? null,
      completed_hours: row['completed_hours'] ?? null,
      id_user_assigned: this.activity == 'task'? this.parseAssignedUsers(row['id_user_assigned']): row['id_user_assigned'],
      id_user_beneficiary: row['id_user_beneficiary'] ?? null,
      name_beneficiary: row['name_beneficiary'] ?? null,
      id_linked_task: row['id_linked_task'] ?? null
    });
  }
  toDate (value: string){
    if (!value) return null;
    const [day, month, year] = value.split('/').map(Number);
    return new Date(year, month - 1, day);
  };
  toggleInternalExpense(){
    this.isInternalExpense = !this.isInternalExpense;
    if(this.isInternalExpense){
      this.activityForm.get('start_date')?.clearValidators();
      this.activityForm.get('end_date')?.clearValidators();
      this.activityForm.get('waves')?.setValidators([Validators.required]);
    }else{
      this.activityForm.get('start_date')?.setValidators([Validators.required]);
      this.activityForm.get('end_date')?.setValidators([Validators.required]);
      this.activityForm.get('waves')?.clearValidators();
    }
    this.activityForm.get('start_date')?.updateValueAndValidity();
    this.activityForm.get('end_date')?.updateValueAndValidity();
    this.activityForm.get('waves')?.updateValueAndValidity();
  }
  parseJson(value: any): any[] {
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  }
  selectedElement(selection: string, element: { [x: string]: string | number | boolean }): boolean {
    const selectedOptions = this.activityForm.get(selection) as FormControl;
    return Array.isArray(selectedOptions?.value) && selectedOptions.value.includes(element['id']);
  }
  parseAssignedUsers(value: any): number[] {
    if (Array.isArray(value)) return value.map(Number);
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) return parsed.map(Number);
      } catch {
        return value.split(',').map(Number).filter(Number.isFinite);
      }
    }
    return value == null ? [] : [Number(value)];
  }

  convertFromEuro(): void {
      const euro = this.activityForm.get('amount_euro')?.value;
      this.activityForm.get('amount_cfa')?.setValue(
          euro !== null && euro !== '' ? Math.round(Number(euro) * 655.957) : null,
          { emitEvent: false }
      );
  }

  convertFromCfa(): void {
      const cfa = this.activityForm.get('amount_cfa')?.value;
      this.activityForm.get('amount_euro')?.setValue(
          cfa !== null && cfa !== '' ? Math.round(Number(cfa) / 655.957 * 100) / 100 : null,
          { emitEvent: false }
      );
  }
  removeUser(userId: number): void {
    if (this.isViewMode) return;
    const ids = this.activityForm.get('id_user_assigned')?.value || [];
    this.activityForm.patchValue({ id_user_assigned: ids.filter((id: number) => id !== userId) });
  }

  onFilesSelected(event: Event): void {
    console.log("Hey")
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    Array.from(input.files).forEach(file => {
      this.attachments.push({
        name: file.name,
        size: this.formatFileSize(file.size),
        file
      });
    });
    input.value = '';
  }

  formatFileSize(size: number): string {
    return size < 1024 * 1024
      ? `${Math.round(size / 1024)} Ko`
      : `${(size / (1024 * 1024)).toFixed(1)} Mo`;
  }

  removeAttachment(index: number): void {
    if (!this.isViewMode){
      let remoteFile = this.rowInfos['attachments'][index]['path'];
      if(remoteFile) this.deleteAttachments.push(remoteFile.split('/').at(-1));
      this.attachments.splice(index, 1);
    } 
  }

  openAttachment(file: any): void {
    console.log(config.master.ndapi+'/'+file.path)
    if (file?.path) window.open(config.master.ndapi.url+'/'+file.path, '_blank', 'noopener,noreferrer');
  }

  addComment(): void {
    const message = this.newComment.trim();
    if (!message || this.isViewMode) return;
    let user = this.users.find((el)=> el.id == this.userInfos['id_user']);
    this.comments.push({
      id_user: this.userInfos['id_user'],
      initials: user.initials,
      color: user.color,
      first_name: user.first_name,
      last_name: user.last_name,
      message,
      date: new Date()
    });
    this.newComment = '';
  }

  resetDates(): void {
    this.activityForm.patchValue({ start_date: null, end_date: null });
  }

  close(): void {
    this.dialogRef.close();
  }

  
  formatDate(date: any) {
    const d = new Date(date);
    return date != null? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} 00:00:00`: null;
  }
}
